import React, { useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import { storeContext } from '../provider/Provider';
import useStyles from './CallDetails.style';
import CallDetailContainer from './CallDetailContainer';



const CallDetails = () => {
  const classes = useStyles();
  const { state } = useContext(storeContext);
  let isPhone = false;

  if (!state.websiteAnalytics.isTesting) {
    isPhone = useMediaQuery({ query: '(max-width: 768px)' });
  }

  return (
    <div className={isPhone ? '' : classes.wrapper}>
      <div className={isPhone ? '' : classes.card} style={{ boxShadow: 'none'}}>
        <div className={isPhone ? '' : classes.card__wrapper}>
          <div style={{
            minHeight: '90vh',
          }}>
            <CallDetailContainer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallDetails;
